var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Modal", {
    attrs: {
      show: _vm.isOpen,
      "close-button-visibility": true,
      alignment: "right",
      animation: "slide-right",
    },
    on: { close: _vm.closeModal, "click:backdrop": _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "language-modal__content" }, [
              _c("h3", { staticClass: "language-modal__title" }, [
                _vm._v(_vm._s(_vm.$t("common.language_selector.title"))),
              ]),
              _c(
                "div",
                { staticClass: "language-modal__languages-list" },
                _vm._l(_vm.availableLanguages, function (lang) {
                  return _c(
                    "div",
                    {
                      key: lang.code,
                      staticClass: "language-modal__language-option",
                      class: {
                        "language-modal__language-option_selected":
                          _vm.isLanguageSelected(lang.code),
                        "language-modal__language-option_pending":
                          _vm.isPendingLanguage(lang.code),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectLanguage(lang.code)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "language-modal__language-info" },
                        [
                          _c(
                            "span",
                            { staticClass: "language-modal__language-name" },
                            [_vm._v(_vm._s(lang.name))]
                          ),
                          _c(
                            "span",
                            { staticClass: "language-modal__language-code" },
                            [
                              _vm._v(
                                "(" +
                                  _vm._s(_vm.getShortLanguageCode(lang.code)) +
                                  ")"
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "svg",
                        {
                          staticClass: "language-modal__check-icon",
                          class: {
                            "language-modal__check-icon_visible":
                              _vm.isPendingLanguage(lang.code) ||
                              (!_vm.pendingLanguage &&
                                _vm.isLanguageSelected(lang.code)),
                          },
                          attrs: {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M20.9887 5.23293C21.4732 5.68514 21.4993 6.44449 21.0471 6.92898L10.2089 18.3978C9.34247 19.3075 7.87258 19.3243 7.00175 18.388L7.00054 18.3867L2.95255 14.0489C2.50039 13.5643 2.52664 12.805 3.01118 12.3528C3.49572 11.9007 4.25506 11.9269 4.70722 12.4115L8.60991 16.5936L19.2927 5.29135C19.7449 4.80686 20.5042 4.78071 20.9887 5.23293Z",
                              fill: "var(--Fill-Accent-100)",
                            },
                          }),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }